export default __webpack_public_path__ + "static/media/Priest's Raiment of the Underworld.b4159372.jpg";